import React from 'react';
import {colors} from '../styles/colors';
import {translate} from 'react-i18next';
import ArrowBack from 'material-ui-icons/ArrowBack';
import {navigationBack} from '../navigation/NavigationActions';
import {connect} from 'react-redux';
import {
	FacebookShareButton,
	WhatsappShareButton,
	EmailShareButton,
	FacebookIcon,
	WhatsappIcon,
	EmailIcon,
} from 'react-share';
import {ListItem} from 'material-ui';
import {getUserSync} from '../utils/auth';
import Link from 'material-ui-icons/Link';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import MyButton from '../components/MyButton';
import TextField from 'material-ui/TextField';
import {fetchRequestPayout} from './RequestPayoutAction';
import {
	INCOMPLETE_DATA,
	PAYOUT_REQUEST_NOT_ALLOWED,
	PAYOUT_REQUEST_SUCCESSFUL,
} from '../utils/constants';
import InfoSnack from '../utils/InfoSnack';
class PayoutScreen extends React.PureComponent {
	constructor() {
		super();

		this.state = {
			bankAccount: null,
		};
	}

	componentDidUpdate(prevProps) {
		if (
			prevProps.requestPayoutSuccess !==
				this.props.requestPayoutSuccess &&
			prevProps.requestPayoutLoading
		) {
			if (this.props.requestPayoutSuccess.msg === INCOMPLETE_DATA) {
				this.infoSnack.showSnack(this.props.t('payout:failed'));
			}
			if (
				this.props.requestPayoutSuccess.msg ===
				PAYOUT_REQUEST_NOT_ALLOWED
			) {
				this.infoSnack.showSnack(this.props.t('payout:notAllowed'));
			}
		} else if (
			prevProps.loadingRequestPayoutFailed !==
				this.props.loadingRequestPayoutFailed &&
			prevProps.requestPayoutLoading
		) {
			this.infoSnack.showSnack(this.props.t('common:cell_failed'));
		}
	}

	convertCents(cents) {
		return Math.trunc(cents / 100);
	}


	handleChange = (name) => (event) => {
		this.setState({
			[name]: event.target.value,
		});
	};

	requestPayout = () => {
		this.props.fetchRequestPayout(this.state.bankAccount);
	};

	render() {
		const {t} = this.props;
		return (
			<div>
				<InfoSnack onRef={(ref) => (this.infoSnack = ref)} />
				<div className='toolbar'>
					<div
						className='back-arrow'
						onClick={() => this.props.goBack()}
					>
						<ArrowBack />
					</div>

					<h2 style={styles.flex}>{t('payout:title')}</h2>
				</div>
				<div style={styles.shareContainer}>
					<h2>{t('payout:subTitle')}</h2>
					<p style={{color: colors.text_light}}>
						{t('payout:titleDescription')}
					</p>
					<div style={styles.textInput}>
						<TextField
							label={t('payout:bankAccount')}
							fullWidth={true}
							required='true'
							onChange={this.handleChange('bankAccount')}
							value={this.state.bankAccount}
						/>
					</div>
					<div style={{marginTop: 30}}>
						<MyButton
							title={t('payout:requestPayout')}
							variant='raised'
							size='large'
							color='primary'
							fullWidth={true}
							loading={this.props.requestPayoutLoading}
							onPressButton={() => this.requestPayout()}
						/>
					</div>
				</div>
			</div>
		);
	}
}

const styles = {
	textInput: {
		paddingTop: 10,
	},
	shareContainer: {
		maxWidth: 512,
		margin: '0 auto',
		paddingTop: 72,
		paddingRight: 16,
		paddingLeft: 16,
	},
	flex: {
		flex: 1,
	},
};

const mapStateToProps = (state) => {
	return {
		requestPayoutLoading: state.requestPayoutLoading,
		requestPayoutSuccess: state.requestPayoutSuccess,
		loadingRequestPayoutFailed: state.loadingRequestPayoutFailed,
		initialOrder: state.initialOrder,
		period: state.period,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchRequestPayout: (bankAccount) =>
			dispatch(fetchRequestPayout(bankAccount)),
		goBack: () => dispatch(navigationBack()),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(translate(['payout', 'common'])(PayoutScreen));



// WEBPACK FOOTER //
// ./src/payout/PayoutScreen.js